import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import {
  requestCasinoPoint,
  requestQTechCasinoID,
} from '../../store/liveCasino/liveCasino.thunks'
import { setLoginNew } from '../../store/LoginNew/loginNew.slice'
import { setSlotCasinoPopUp } from '../../store/slotCasinoPopUp/slotCasinoPopUp.slice'
import { USER_DATA } from '../../config/app.config'
import { toastr } from 'react-redux-toastr'
import { getMenuSuccess } from '../../store/menu/menu.slice'
import {
  setIsAnimatedMenu,
  setIsDetailedGroup,
  setIsMoreDetailed,
  setIsNavigationID,
  setIsNavigationName,
  setIsNavigationOpen,
  setRenderIonContent,
} from '../../store/navigationHeaderMenu/navigationHeaderMenu.slice'

const HomeTopCasino = ({ isSportAvailable }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const auth = useSelector((state) => state.auth)

  const onSelectGame = (id, code) => {
    if (auth) {
      let data = { gameId: id, providerCode: code }
      dispatch(requestQTechCasinoID(data))
      history.push(`/live_casino_slot/${id}`)
    } else {
      dispatch(setLoginNew(true))
    }
  }

  const onSelectGameGap = (path) => {
    if (auth) {
      history.push(path)
    } else {
      dispatch(setLoginNew(true))
    }
  }

  // gap-casino/242455/Crash Games/DC

  const width = window.innerWidth

  let user = localStorage.getItem(USER_DATA)
  let userData = JSON.parse(user)

  const handleNav = (id, code, provider_name) => {
    if (userData?.is_demo) {
      toastr.error('', 'Please login from your read ID.')
      return
    }
    if (isSportAvailable('QT')) {
      onSelectGame(id, code)
    } else {
      onSelectGameGap(`/gap-casino/${id}/${code}/${provider_name}`)
    }
    dispatch(setSlotCasinoPopUp(true))
    dispatch(requestCasinoPoint())
  }

  const handleFunGame = () => {
    if (!auth) {
      dispatch(setLoginNew(true))
      return
    }
    if (userData?.is_demo) {
      toastr.error('', 'Please login from your read ID.')
      return
    }

    dispatch(getMenuSuccess([]))
    {
      dispatch(setSlotCasinoPopUp(true))
      dispatch(requestCasinoPoint())

      dispatch(setIsNavigationOpen(true))
      dispatch(setRenderIonContent(false))
      // dispatch(setIsAnimatedMenu(true)
      setTimeout(() => {
        dispatch(setIsNavigationOpen(false))
      }, 400)
      setTimeout(() => {
        dispatch(setIsAnimatedMenu(false))
      }, 400)
      dispatch(setIsNavigationID('QT'))
      dispatch(setIsNavigationName('QTech'))
      dispatch(setIsMoreDetailed('SPB'))
      dispatch(setIsDetailedGroup(''))
    }
    if (width < 1024) {
      let page = `/menu-event/QT/SBP`
      history.push({
        pathname: page,
        state: { id: 'QT' },
      })
    } else {
      history.push('/sports-page')
    }
  }

  const handleAura = () => {
    if (!auth) {
      dispatch(setLoginNew(true))
      return
    }
    if (userData?.is_demo) {
      toastr.error('', 'Please login from your read ID.')
      return
    }
    history.push('/casino_live/70011')
  }

  //  `/gap-casino/${data.game_id}/${data?.category}/${data?.provider_name}`

  return (
    <section className="click-inplay-games-content">
      <div className="row">
        <div className="col-6 pl-1 pe-1">
          <Link
            to="#"
            onClick={() => {
              if (isSportAvailable('QT')) {
                handleNav('SPB-aviator', 'SPB')
              } else {
                handleNav('242455', 'Crash Games', 'DC')
              }
            }}
          >
            <div className="m-game-card new-games-sec">
              <img
                alt="aviator"
                src="/bonus/aviator.gif"
                className="click-inplay-games-img click-inplay-games-img-height"
              />
            </div>
          </Link>
        </div>
        <div className="col-6 ps-1">
          <Link onClick={handleAura} to="#">
            <div className="m-game-card new-games-sec">
              <img
                alt="mines"
                src="/bonus/mines.gif"
                className="click-inplay-games-img click-inplay-games-img-height"
              />
            </div>
          </Link>
        </div>
        <div className="col-6 pl-1 pe-1">
          <Link to="#" onClick={handleFunGame}>
            <div className="m-game-card new-games-sec">
              <img
                alt="fungames"
                src="/bonus/fungames.gif"
                className="click-inplay-games-img click-inplay-games-img-height"
              />
            </div>
          </Link>
        </div>
        <div className="col-6 ps-1">
          <Link
            to="#"
            onClick={() => {
              if (isSportAvailable('QT')) {
                handleNav('JIL-colorprediction', 'JIL')
              } else {
                handleNav('600144', 'Slot Games', 'JiLi')
              }
            }}
          >
            <div className="m-game-card new-games-sec">
              <img
                alt="color-pridiction"
                src="/bonus/color-pridiction.gif"
                className="click-inplay-games-img click-inplay-games-img-height"
              />
            </div>
          </Link>
        </div>
      </div>
    </section>
  )
}

export default HomeTopCasino